import { RouteConfig } from '@dojo/framework/routing/interfaces';

const routes: RouteConfig[] = [
	{
		id: 'home',
		path: '/',
		outlet: 'main',
		defaultRoute: true
	},
	{
		id: 'contact',
		path: 'contact',
		outlet: 'main'
	},
	{
		id: 'strategySession',
		path: 'strategy-session',
		outlet: 'main'
	},
	{
		id: 'contactThankyou',
		path: 'contact-thank-you',
		outlet: 'main'
	},
	{
		id: 'expertise',
		path: 'expertise',
		outlet: 'main',
		children: [
			{
				id: 'expertiseAgileConsulting',
				path: 'agile-consulting',
				outlet: 'main'
			},
			{
				id: 'expertiseAngular',
				path: 'angular-js-development',
				outlet: 'main'
			},
			{
				id: 'expertiseDojo',
				path: 'dojo-development',
				outlet: 'main'
			},
			{
				id: 'expertiseJavascript',
				path: 'javascript-development',
				outlet: 'main'
			},
			{
				id: 'expertiseFullStack',
				path: 'full-stack-javascript-development',
				outlet: 'main'
			},
			{
				id: 'expertiseNode',
				path: 'node-js-development',
				outlet: 'main'
			},
			{
				id: 'expertiseReact',
				path: 'react-js-development',
				outlet: 'main'
			},
			{
				id: 'expertiseTypeScript',
				path: 'typescript-development',
				outlet: 'main'
			},
			{
				id: 'expertiseVue',
				path: 'vue-development',
				outlet: 'main'
			}
		]
	},
	{
		id: 'work',
		path: 'our-work',
		outlet: 'main'
	},
	{
		id: 'services',
		path: 'services',
		outlet: 'main',
		children: [
			{
				id: 'servicesAutomatedTesting',
				path: 'automated-testing',
				outlet: 'main'
			},
			{
				id: 'servicesCrossPlatformDevelopment',
				path: 'cross-platform-development',
				outlet: 'main'
			},
			{
				id: 'servicesCustomSoftwareDevelopment',
				path: 'custom-software-development',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseArchitecture',
				path: 'enterprise-architecture',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseDevOpsSolutions',
				path: 'enterprise-devops-solutions',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseSoftwareDevelopment',
				path: 'enterprise-software-development',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseCloudServices',
				path: 'enterprise-cloud-services',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseTechnologyStrategy',
				path: 'enterprise-technology-strategy',
				outlet: 'main'
			},
			{
				id: 'servicesEnterpriseUX',
				path: 'enterprise-ux-design',
				outlet: 'main'
			},
			{
				id: 'servicesPerformanceOptimization',
				path: 'performance-optimization',
				outlet: 'main'
			},
			{
				id: 'servicesPerformanceTesting',
				path: 'performance-testing',
				outlet: 'main'
			},
			{
				id: 'servicesQualityAssurance',
				path: 'quality-assurance',
				outlet: 'main'
			},
			{
				id: 'servicesRapidPrototyping',
				path: 'rapid-prototyping-and-design',
				outlet: 'main'
			},
			{
				id: 'servicesSoftwareArchitecture',
				path: 'software-architecture-design',
				outlet: 'main'
			},
			{
				id: 'servicesSoftwareModernization',
				path: 'legacy-software-modernization',
				outlet: 'main'
			},
			{
				id: 'servicesUIDesign',
				path: 'ui-design',
				outlet: 'main'
			},
			{
				id: 'servicesUXDesign',
				path: 'ux-design',
				outlet: 'main'
			},
			{
				id: 'servicesWebApplicationDevelopment',
				path: 'web-application-development',
				outlet: 'main'
			}
		]
	},
	{
		id: 'privacy',
		path: 'privacy-policy',
		outlet: 'main'
	},
	{
		id: 'opensource',
		path: 'open-source',
		outlet: 'main'
	},
	{
		id: 'opensourceDojo',
		path: 'open-source/dojo-framework',
		outlet: 'main'
	},
	{
		id: 'opensourceDgrid',
		path: 'open-source/dgrid',
		outlet: 'main'
	},
	{
		id: 'opensourceIntern',
		path: 'open-source/intern',
		outlet: 'main'
	},
	{
		id: 'opensourceTypescript',
		path: 'open-source/typescript',
		outlet: 'main'
	},
	{
		id: 'opensourceDojoToolkit',
		path: 'open-source/dojo-toolkit',
		outlet: 'main'
	},
	{
		id: 'about',
		path: 'about-us',
		outlet: 'main'
	},
	{
		id: 'careers',
		path: 'careers',
		outlet: 'main',
		children: [
			{
				id: 'careerPage',
				path: '{jobId}',
				outlet: 'main'
			}
		]
	},
	{
		id: 'casestudyFannie',
		path: 'case-study/fannie-mae',
		outlet: 'main'
	},
	{
		id: 'casestudyMarriott',
		path: 'case-study/marriott',
		outlet: 'main'
	},
	{
		id: 'casestudyBuilt',
		path: 'case-study/built-technologies',
		outlet: 'main'
	},
	{
		id: 'casestudySocialRVComplete',
		path: 'case-study/social-knowledge/rv-complete',
		outlet: 'main'
	},
	{
		id: 'casestudySocialRVLife',
		path: 'case-study/social-knowledge/rv-life',
		outlet: 'main'
	},
	{
		id: 'casestudySocialTripWizard',
		path: 'case-study/social-knowledge/trip-wizard',
		outlet: 'main'
	},
	{
		id: 'casestudyCentric',
		path: 'case-study/centric',
		outlet: 'main'
	},
	{
		id: 'casestudyTRowePrice',
		path: 'case-study/trowe-price',
		outlet: 'main'
	},
	{
		id: 'casestudyIntuit',
		path: 'case-study/intuit',
		outlet: 'main'
	},
	{
		id: 'blog',
		outlet: 'main',
		path: 'blog',
		children: [
			{
				id: 'category',
				outlet: 'main',
				path: 'category/{slug}'
			},
			{
				id: 'series',
				outlet: 'main',
				path: 'series/{slug}'
			},
			{
				id: 'search',
				outlet: 'main',
				path: 'search?{term}'
			},
			{
				id: 'blogPage',
				outlet: 'main',
				path: '{slugOrPage}'
			}
		]
	},
	{
		id: 'previewLatestInsights',
		outlet: 'iframe',
		path: 'preview/latest-insights'
	},
	{
		id: 'previewSeries',
		outlet: 'iframe',
		path: 'preview/series/{slug}'
	},
	{
		id: 'newsletterForm',
		outlet: 'iframe',
		path: 'newsletter/form'
	},
	{
		id: 'newsletterSubmit',
		outlet: 'iframe',
		path: 'newsletter/submit?email&_gotcha'
	},
	{
		id: 'previewSeriesLinks',
		path: 'preview/series/links',
		outlet: 'main'
	},
	{
		id: 'error404',
		path: 'error-404',
		outlet: 'main'
	}
];

export default routes;
